import React from 'react';
import EVAverageGraph, {EVAverageGraphType} from '@di-shared/features/home/kr/ev-battery/EVAverageGraph';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {GetEvBatteryManagementChargeResponse} from '@di-shared/api/di/__generated';
import fastChargingStatus = GetEvBatteryManagementChargeResponse.fastChargingStatus;

interface FastChargeRatioProps {
  user: ChargeCount;
  avgCustomer: ChargeCount;
  fastChargingStatus: fastChargingStatus;
}

interface ChargeCount {
  fastChargeCount: number;
  slowChargeCount: number;
}

function getDescKey(fastChargeRatioType: fastChargingStatus) {
  switch (fastChargeRatioType) {
    case fastChargingStatus.LOW:
      return 'T30422';
    case fastChargingStatus.MEDIUM:
      return 'T30423';
    case fastChargingStatus.HIGH:
      return 'T30424';
  }
}

function FastChargeRatio({user, avgCustomer, fastChargingStatus}: FastChargeRatioProps) {
  const {t} = useInferableTranslation();
  return (
    <EVAverageGraph
      title={t('T30418')}
      desc={t(getDescKey(fastChargingStatus))}
    >
      <EVAverageGraph.BarGraph
        filledAreaRatio={user.fastChargeCount / (user.slowChargeCount + user.fastChargeCount)}
        dashedAreaRatio={avgCustomer.fastChargeCount / (avgCustomer.slowChargeCount + avgCustomer.fastChargeCount)}
        graphType={EVAverageGraphType.TYPE_FAST_CHARGE}
        Tags={[
          {title: t('T30419'), count: user.slowChargeCount},
          {
            title: t('T30420'),
            count: user.fastChargeCount,
            type: EVAverageGraphType.TYPE_FAST_CHARGE,
          },
        ]}
      />
    </EVAverageGraph>
  );
}

export default FastChargeRatio;
